export default {"src":"/_next/static/media/location.19dc51a7.svg","height":15,"width":15};